import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const LanguageToggle = () => {
  const { language, toggleLanguage, t } = useLanguage();

  return (
    <button
      className="toggle-btn"
      onClick={toggleLanguage}
      aria-label="Toggle language"
      title={language === 'mr' ? 'Switch to English' : 'मराठीत बदला'}
    >
      <i className="bi bi-translate"></i>
      {language === 'mr' ? t('common.english') : t('common.marathi')}
    </button>
  );
};

export default LanguageToggle;
